var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0023 20.0908C41.0023 30.8954 31.9509 39.6816 20.7511 39.6816C9.55138 39.6816 0.5 30.8954 0.5 20.0908C0.5 9.28621 9.55138 0.5 20.7511 0.5C31.9509 0.5 41.0023 9.28621 41.0023 20.0908Z",
    stroke: "white",
    strokeOpacity: 0.79
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9248 15.7293C24.8572 16.0434 24.7874 16.3569 24.7222 16.6716C24.2247 19.0671 23.7285 21.4626 23.2313 23.8581C23.1943 24.0366 23.1606 24.2164 23.1154 24.3931C22.948 25.0502 22.4823 25.011 22.1208 24.7439C21.377 24.1949 20.6426 23.6331 19.9042 23.0766C19.7944 22.9937 19.6813 22.9152 19.5757 22.827C19.5157 22.7769 19.4793 22.7831 19.425 22.837C18.9976 23.2614 18.5665 23.682 18.1376 24.1052C18.0099 24.2311 17.8649 24.3083 17.6707 24.3012C17.682 24.1295 17.6923 23.9637 17.7038 23.798C17.7542 23.072 17.803 22.3456 17.8582 21.6199C17.8624 21.5626 17.8967 21.4937 17.9383 21.4551C19.5433 19.967 21.1507 18.4819 22.7578 16.9962C22.7775 16.9782 22.8039 16.9635 22.8154 16.9408C22.8412 16.8897 22.8594 16.8345 22.8809 16.7809C22.8254 16.766 22.7654 16.7292 22.7159 16.7407C22.6261 16.7622 22.5363 16.8018 22.4578 16.8526C20.4569 18.1382 18.4573 19.4257 16.4589 20.7157C16.3843 20.764 16.3224 20.7699 16.2402 20.7431C15.4045 20.4724 14.5669 20.2078 13.7315 19.9355C13.622 19.8996 13.5131 19.8448 13.4203 19.7756C13.2677 19.6619 13.2483 19.4974 13.3842 19.3662C13.4974 19.2571 13.6336 19.1584 13.777 19.1001C14.6094 18.7614 15.4463 18.4355 16.2823 18.1061C18.8923 17.0769 21.5019 16.0484 24.1125 15.022C24.1962 14.9893 24.2863 14.9637 24.3749 14.9572C24.6494 14.9366 24.829 15.0753 24.9003 15.3489C24.9069 15.3747 24.9167 15.4 24.9248 15.4255V15.7293Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6316,
    height: 9.96996,
    fill: "white",
    transform: "translate(13.2933 14.955)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocTwo);
export default __webpack_public_path__ + "static/media/soc-two.36c26a25f582a026b9c7a856c0d598cf.svg";
export { ForwardRef as ReactComponent };